import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tag } from 'antd';
import INTRO_KEYS from "../../../constants/IntroKeys";
import { Enumify } from "enumify-ts";
class UserRoleType extends Enumify() {
    title;
    gettingStartedIntroKey;
    powerLevel;
    static SUBTRUX_TECH_SUPPORT = new UserRoleType("SubTrux Tech Support", null, 99999999);
    static SUBTRUX_ADMIN_ACCOUNTS = new UserRoleType("SubTrux Accounts Administrator", null, 7000000);
    static SUBTRUX_ADMIN = new UserRoleType("SubTrux Administrator", null, 6000000);
    static SUBTRUX_OPERATIONS = new UserRoleType("SubTrux Operations", null, 5000000);
    static TENANT_ADMIN = new UserRoleType("Profile Administrator", INTRO_KEYS.DMS, 10000);
    static DRIVER = new UserRoleType("Driver", INTRO_KEYS.DMS, 3500);
    static OPERATIONS = new UserRoleType("Operations", INTRO_KEYS.DMS, 4500);
    static OPERATIONS_MANAGER = new UserRoleType("Operations Manager", INTRO_KEYS.DMS, 5000);
    static SALES_PERSON = new UserRoleType("Sales Person", INTRO_KEYS.DMS, 4000);
    static SALES_MANAGER = new UserRoleType("Sales Manager", INTRO_KEYS.DMS, 4250);
    static CUSTOMER_SUPPORT_READ_ONLY = new UserRoleType("Customer Support Read Only", null, 2750);
    static CUSTOMER_SUPPORT_WITH_EDIT = new UserRoleType("Customer Support with Edit", null, 3000);
    static MARKETPLACE_SALES_ADMIN = new UserRoleType("Marketplace Sales Administrator", INTRO_KEYS.MARKETPLACE, 2250);
    static MARKETPLACE_ADMIN = new UserRoleType("Marketplace Administrator", INTRO_KEYS.MARKETPLACE, 2000);
    static MARKETPLACE_OPERATIONS = new UserRoleType("Marketplace Operations", INTRO_KEYS.MARKETPLACE, 1000);
    static MARKETPLACE_VIEW_ONLY = new UserRoleType("Marketplace View Only", INTRO_KEYS.MARKETPLACE, 500);
    static DIVISIONAL = new UserRoleType("Divisional", INTRO_KEYS.DMS, 8000);
    static FLEET_ADMIN = new UserRoleType("Fleet Administrator", INTRO_KEYS.CONTRACTOR, 6000);
    static DELIVERY_MANAGER = new UserRoleType("Delivery Manager", INTRO_KEYS.DMS, 7000);
    static PROCUREMENT = new UserRoleType("Procurement", INTRO_KEYS.DMS, 5500);
    static PROCUREMENT_MANAGER = new UserRoleType("Procurement Manager", INTRO_KEYS.DMS, 5750);
    static _ = UserRoleType._closeEnum();
    constructor(title, gettingStartedIntroKey, powerLevel) {
        super();
        this.title = title;
        this.gettingStartedIntroKey = gettingStartedIntroKey;
        this.powerLevel = powerLevel;
    }
    renderTag() {
        return _jsx(Tag, { children: this.title }, this.key);
    }
    static filtersArray(maxPowerLevel) {
        return UserRoleType.values
            .filter(t => t.powerLevel <= maxPowerLevel)
            .map(t => {
            return { text: t.title, value: t.key };
        });
    }
}
export default UserRoleType;
